import { Injectable, ErrorHandler } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: any): void {
    if (error?.message?.includes('Loading chunk')) {
       setTimeout(() => window.location.reload(), 1500);
    } else {
      console.error('เกิดข้อผิดพลาดในระบบ', 'ข้อผิดพลาด', error);
    }
  }
}
